var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "payout-detail-modal" },
    [
      _c(
        "el-dialog",
        {
          staticClass: "diglog-card",
          attrs: {
            title: _vm.$t("data.payout_details"),
            visible: _vm.dialogTableVisible,
            width: "1000px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogTableVisible = $event
            },
            open: _vm.getDetailInfo,
          },
        },
        [
          _vm.$store.getters.isPii
            ? _c("div", { staticClass: "header-line" })
            : _vm._e(),
          _vm.merchantInfo.transaction_type === _vm.TRANSACTION_TYPE_FX
            ? [
                _c("div", { staticClass: "total" }, [
                  _c("div", { staticClass: "total-item" }, [
                    _c("div", { staticClass: "total-title" }, [
                      _vm._v(_vm._s(_vm.$t("data.destination_amount")) + ":"),
                    ]),
                    _c("div", { staticClass: "total-num" }, [
                      _vm._v(
                        " " +
                          _vm._s(_vm.merchantInfo.destination_currency) +
                          " " +
                          _vm._s(
                            _vm._f("toDivideWithDot")(
                              _vm.merchantInfo.destination_amount
                            )
                          )
                      ),
                    ]),
                  ]),
                  _c("div", { staticClass: "line" }),
                  _c("div", { staticClass: "total-item" }, [
                    _c("div", { staticClass: "total-title" }, [
                      _vm._v(_vm._s(_vm.$t("data.fee")) + ":"),
                    ]),
                    _c("div", { staticClass: "total-num" }, [
                      _vm._v(
                        _vm._s(
                          _vm.merchantInfo.mch_foreign_exchange_fee_resp
                            .fee_split_currency
                        ) +
                          " " +
                          _vm._s(
                            _vm._f("toDivideWithDot")(
                              _vm.merchantInfo.mch_foreign_exchange_fee_resp
                                .fee_split
                            )
                          )
                      ),
                    ]),
                  ]),
                ]),
                _c("div", { staticClass: "total" }, [
                  _c("div", { staticClass: "total-item" }, [
                    _c("div", { staticClass: "total-title" }, [
                      _vm._v(_vm._s(_vm.$t("data.source_amount")) + ":"),
                    ]),
                    _c("div", { staticClass: "total-num" }, [
                      _vm._v(
                        _vm._s(_vm.merchantInfo.source_currency) +
                          " " +
                          _vm._s(
                            _vm._f("toDivideWithDot")(
                              _vm.merchantInfo.source_amount
                            )
                          )
                      ),
                    ]),
                  ]),
                ]),
              ]
            : [
                _c("div", { staticClass: "total" }, [
                  _c("div", { staticClass: "total-item" }, [
                    _c("div", { staticClass: "total-title" }, [
                      _vm._v(_vm._s(_vm.$t("data.destination_amount")) + ":"),
                    ]),
                    _c("div", { staticClass: "total-num" }, [
                      _vm._v(
                        " " +
                          _vm._s(_vm.$store.getters.currency) +
                          " " +
                          _vm._s(
                            _vm._f("toDivideWithDot")(
                              _vm.merchantInfo.po_trans_amount
                            )
                          )
                      ),
                    ]),
                  ]),
                  _c("div", { staticClass: "line" }),
                  _c("div", { staticClass: "total-item" }, [
                    _c("div", { staticClass: "total-title" }, [
                      _vm._v(_vm._s(_vm.$t("data.fee")) + ":"),
                    ]),
                    _c("div", { staticClass: "total-num" }, [
                      _vm._v(
                        _vm._s(_vm.$store.getters.currency) +
                          " " +
                          _vm._s(
                            _vm._f("toDivideWithDot")(
                              _vm.merchantInfo.fee_split
                            )
                          )
                      ),
                    ]),
                  ]),
                ]),
              ],
          _c("div", { staticClass: "section-title" }, [
            _vm._v(" " + _vm._s(_vm.$t("data.timeline")) + " "),
          ]),
          _c("div", { staticClass: "line-bottom-1px" }),
          _c("div", { staticClass: "item" }, [
            _c("span", { staticClass: "item-left content-blue" }, [
              _vm._v(_vm._s(_vm.$t("data.payout_created"))),
            ]),
            _c("span", { staticClass: "content-blue" }, [
              _vm._v(_vm._s(_vm.$t("data.payout_completed"))),
            ]),
          ]),
          _c("div", { staticClass: "item" }, [
            _c(
              "span",
              { staticClass: "item-left", staticStyle: { color: "#4B5567" } },
              [_vm._v(_vm._s(_vm.merchantInfo.transaction_create_time))]
            ),
            _c("span", { staticClass: "content-gray" }, [
              _vm._v(_vm._s(_vm.merchantInfo.transaction_return_time)),
            ]),
          ]),
          _c("div", { staticClass: "section-title" }, [
            _vm._v(" " + _vm._s(_vm.$t("data.description")) + " "),
          ]),
          _c("div", { staticClass: "line-bottom-1px" }),
          _c("div", { staticClass: "item" }, [
            _c("span", { staticClass: "item-left content-blue" }, [
              _vm._v(_vm._s(_vm.$t("customerService.transaction_id"))),
            ]),
            _c("span", { staticClass: "content-gray" }, [
              _vm._v(_vm._s(_vm.merchantInfo.transaction_id)),
            ]),
          ]),
          _c("div", { staticClass: "item" }, [
            _c("span", { staticClass: "item-left content-blue" }, [
              _vm._v(_vm._s(_vm.$t("customerService.merchant_order_id"))),
            ]),
            _c("span", { staticClass: "content-gray" }, [
              _vm._v(_vm._s(_vm.merchantInfo.merchant_order_id)),
            ]),
          ]),
          _c("div", { staticClass: "item" }, [
            _c("span", { staticClass: "item-left content-blue" }, [
              _vm._v(_vm._s(_vm.$t("customerService.remitting_bank"))),
            ]),
            _c("span", { staticClass: "content-gray" }, [
              _vm._v(_vm._s(_vm.merchantInfo.sender_bank_name)),
            ]),
          ]),
          _c("div", { staticClass: "item" }, [
            _c("span", { staticClass: "item-left content-blue" }, [
              _vm._v(_vm._s(_vm.$t("customerService.remittance_account"))),
            ]),
            _c("span", { staticClass: "content-gray" }, [
              _vm._v(
                _vm._s(
                  _vm._f("strAesDecryptAndAsterisk")(
                    _vm.merchantInfo.sender_bank_account
                  )
                )
              ),
            ]),
          ]),
          _c("div", { staticClass: "item" }, [
            _c("span", { staticClass: "item-left content-blue" }, [
              _vm._v(_vm._s(_vm.$t("merchantAccount.recipient_name"))),
            ]),
            _c("span", { staticClass: "content-gray" }, [
              _vm._v(
                _vm._s(
                  _vm._f("strAesDecryptAndAsterisk")(
                    _vm.merchantInfo.recipient_name
                  )
                )
              ),
            ]),
          ]),
          _c("div", { staticClass: "item" }, [
            _c("span", { staticClass: "item-left content-blue" }, [
              _vm._v(_vm._s(_vm.$t("merchantAccount.recipient_channel"))),
            ]),
            _c("span", { staticClass: "content-gray" }, [
              _vm._v(_vm._s(_vm.merchantInfo.recipient_channel || "-")),
            ]),
          ]),
          _c("div", { staticClass: "item" }, [
            _c("span", { staticClass: "item-left content-blue" }, [
              _vm._v(_vm._s(_vm.$t("merchantAccount.recipient_account"))),
            ]),
            _c("span", { staticClass: "content-gray" }, [
              _vm._v(
                _vm._s(
                  _vm._f("strAesDecryptAndAsterisk")(
                    _vm.merchantInfo.recipient_account
                  )
                )
              ),
            ]),
          ]),
          _vm.merchantInfo.sender_bank_name !== "PYVIO"
            ? _c("div", { staticClass: "item" }, [
                _c("span", { staticClass: "item-left content-blue" }, [
                  _vm._v(_vm._s(_vm.$t("merchantAccount.beneficiary_mobile"))),
                ]),
                _c("span", { staticClass: "content-gray" }, [
                  _vm._v(
                    _vm._s(
                      _vm._f("strAesDecryptAndAsterisk")(
                        _vm.merchantInfo.mobile
                      )
                    )
                  ),
                ]),
              ])
            : _vm._e(),
          _vm.$store.getters.curCountry.country_code === "AE"
            ? _c("div", { staticClass: "item" }, [
                _c("span", { staticClass: "item-left content-blue" }, [
                  _vm._v(_vm._s(_vm.$t("map.benefit_address"))),
                ]),
                _c("span", { staticClass: "content-gray" }, [
                  _vm._v(_vm._s(_vm.merchantInfo.beneficiary_address)),
                ]),
              ])
            : _vm._e(),
          _c("div", { staticClass: "item" }, [
            _c("span", { staticClass: "item-left content-blue" }, [
              _vm._v(_vm._s(_vm.$t("system.remark"))),
            ]),
            _c("span", { staticClass: "content-gray" }, [
              _vm._v(_vm._s(_vm.merchantInfo.remark)),
            ]),
          ]),
          _vm.merchantInfo.transaction_type === _vm.TRANSACTION_TYPE_FX
            ? [
                _c("div", { staticClass: "item" }, [
                  _c("span", { staticClass: "item-left content-blue" }, [
                    _vm._v(_vm._s(_vm.$t("data.quote_id"))),
                  ]),
                  _c("span", { staticClass: "content-gray" }, [
                    _vm._v(_vm._s(_vm.merchantInfo.quote_id)),
                  ]),
                ]),
                _c("div", { staticClass: "item" }, [
                  _c("span", { staticClass: "item-left content-blue" }, [
                    _vm._v(_vm._s(_vm.$t("data.exchange_rate"))),
                  ]),
                  _c("span", { staticClass: "content-gray" }, [
                    _vm._v(_vm._s(_vm.merchantInfo.exchange_rate)),
                  ]),
                ]),
                _c("div", { staticClass: "item" }, [
                  _c("span", { staticClass: "item-left content-blue" }, [
                    _vm._v(_vm._s(_vm.$t("data.exchange_transaction_id"))),
                  ]),
                  _c("span", { staticClass: "content-gray" }, [
                    _vm._v(_vm._s(_vm.merchantInfo.exchange_no)),
                  ]),
                ]),
              ]
            : _vm._e(),
          _vm.merchantInfo.po_trans_status === _vm.TRANSACTION_STATUS["fail"]
            ? _c("div", { staticClass: "item" }, [
                _c("span", { staticClass: "item-left content-blue" }, [
                  _vm._v(_vm._s(_vm.$t("data.fail_reason"))),
                ]),
                _c("span", { staticClass: "content-gray" }, [
                  _vm._v(_vm._s(_vm.merchantInfo.fail_reason)),
                ]),
              ])
            : _vm._e(),
          _c(
            "el-tag",
            {
              class: {
                "payout-status": true,
                "tag-custom": true,
                "is-pii": _vm.$store.getters.isPii,
              },
              attrs: {
                type: _vm.getPOTransactionStatusType(
                  _vm.merchantInfo.po_trans_status
                ),
                "min-width": "150",
              },
            },
            [
              _vm._v(
                " " +
                  _vm._s(
                    _vm.getPOTransactionStatusLabel(
                      _vm.merchantInfo.po_trans_status,
                      _vm.merchantInfo.refund_type
                    )
                  )
              ),
            ]
          ),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }